// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "ShopAdd" + "-legacy." + "2fba911e" + ".js";
};